var _defs, _rect, _rect2, _rect3, _circle, _circle2, _ellipse, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecoveryMachine2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steel",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelDark",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4a545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c333a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a201b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper",
    x1: 0,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c79b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9853f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96501a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperEdge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b06428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3c295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4a16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0dfa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8a83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lcd",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fb37c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shellWhite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eef1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#243021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#161d14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0f0a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0.5,
    cy: 0.46,
    r: 0.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BAE66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 0 L 0 0 0 60",
    fill: "none",
    stroke: "#8BAE66",
    strokeOpacity: 0.07,
    strokeWidth: 1.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#halo)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 318,
    fill: "none",
    stroke: "#8BAE66",
    strokeOpacity: 0.22,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 292,
    fill: "none",
    stroke: "#8BAE66",
    strokeOpacity: 0.1,
    strokeWidth: 16
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 720,
    rx: 250,
    ry: 42,
    fill: "#000000",
    opacity: 0.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 470) scale(0.86) rotate(-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -220,
    y: -52,
    width: 440,
    height: 230,
    rx: 26,
    fill: "url(#steelDark)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -220,
    y: -52,
    width: 440,
    height: 60,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: -196,
    y: 60,
    width: 180,
    height: 96,
    rx: 12,
    fill: "#20261f"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -171.3,
    y1: 68,
    x2: -171.3,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.7,
    y1: 68,
    x2: -152.7,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -134,
    y1: 68,
    x2: -134,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -115.3,
    y1: 68,
    x2: -115.3,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.7,
    y1: 68,
    x2: -96.7,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -78,
    y1: 68,
    x2: -78,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -59.3,
    y1: 68,
    x2: -59.3,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40.7,
    y1: 68,
    x2: -40.7,
    y2: 148,
    stroke: "#8a949a",
    strokeOpacity: 0.35,
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 60,
    width: 186,
    height: 96,
    rx: 12,
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 107,
    y: 122,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 30,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 0.85,
    textAnchor: "middle",
    letterSpacing: 1.8
  }, "RECOVERY"), /*#__PURE__*/React.createElement("circle", {
    cx: -108,
    cy: -74,
    r: 74,
    fill: "#1f6fb2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -108,
    cy: -74,
    r: 66,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -108,
    cy: -74,
    r: 62,
    fill: "#f4f7f8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147.8,
    y1: -51,
    x2: -158.2,
    y2: -45,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -153.3,
    y1: -66,
    x2: -165.1,
    y2: -63.9,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -153.3,
    y1: -82,
    x2: -165.1,
    y2: -84.1,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147.8,
    y1: -97,
    x2: -158.2,
    y2: -103,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -137.6,
    y1: -109.2,
    x2: -145.3,
    y2: -118.4,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -123.7,
    y1: -117.2,
    x2: -127.8,
    y2: -128.5,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -108,
    y1: -120,
    x2: -108,
    y2: -132,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -92.3,
    y1: -117.2,
    x2: -88.2,
    y2: -128.5,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -78.4,
    y1: -109.2,
    x2: -70.7,
    y2: -118.4,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -68.2,
    y1: -97,
    x2: -57.8,
    y2: -103,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -62.7,
    y1: -82,
    x2: -50.9,
    y2: -84.1,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -62.7,
    y1: -66,
    x2: -50.9,
    y2: -63.9,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -108,
    y1: -74,
    x2: -77.4,
    y2: -99.7,
    stroke: "#c0392b",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -108,
    cy: -74,
    r: 9,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -125.36,
    cy: -95.08,
    rx: 28.52,
    ry: 18.599999999999998,
    fill: "url(#glass)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -74,
    r: 74,
    fill: "#c0392b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -74,
    r: 66,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -74,
    r: 62,
    fill: "#f4f7f8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.2,
    y1: -51,
    x2: 5.8,
    y2: -45,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7,
    y1: -66,
    x2: -1.1,
    y2: -63.9,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7,
    y1: -82,
    x2: -1.1,
    y2: -84.1,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.2,
    y1: -97,
    x2: 5.8,
    y2: -103,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.4,
    y1: -109.2,
    x2: 18.7,
    y2: -118.4,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.3,
    y1: -117.2,
    x2: 36.2,
    y2: -128.5,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: -120,
    x2: 56,
    y2: -132,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7,
    y1: -117.2,
    x2: 75.8,
    y2: -128.5,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.6,
    y1: -109.2,
    x2: 93.3,
    y2: -118.4,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.8,
    y1: -97,
    x2: 106.2,
    y2: -103,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.3,
    y1: -82,
    x2: 113.1,
    y2: -84.1,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.3,
    y1: -66,
    x2: 113.1,
    y2: -63.9,
    stroke: "#4a545c",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: -74,
    x2: 31.4,
    y2: -105.5,
    stroke: "#c0392b",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -74,
    r: 9,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.64,
    cy: -95.08,
    rx: 28.52,
    ry: 18.599999999999998,
    fill: "url(#glass)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: -58,
    r: 26,
    fill: "#c0392b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: -58,
    r: 12,
    fill: "#8c2418"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 8,
    r: 26,
    fill: "#1f6fb2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 8,
    r: 12,
    fill: "#0f4d80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140,-160 L-140,-186 Q-140,-202 -122,-202 L122,-202 Q140,-202 140,-186 L140,-160",
    fill: "none",
    stroke: "#262d24",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -206,
    y: 178,
    width: 60,
    height: 26,
    rx: 8,
    fill: "#20261f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 178,
    width: 60,
    height: 26,
    rx: 8,
    fill: "#20261f"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 82,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#a3c46f",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 3.08
  }, "Value")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 854,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 0.6,
    textAnchor: "start",
    letterSpacing: 1.04
  }, "Refrigerant Recovery Machine")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryMachine2);
export default __webpack_public_path__ + "static/media/recovery-machine-2.add54793c36b6c8fe01e406d4184e630.svg";
export { ForwardRef as ReactComponent };